import * as React from "react";
const SvgFiRrThermometerFull = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M13 14.184V5a1 1 0 1 0-2 0v9.184A3 3 0 0 0 9 17c0 1.654 1.346 3 3 3s3-1.346 3-3a3 3 0 0 0-2-2.816M12 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2m5-5.889V5c0-2.757-2.243-5-5-5S7 2.243 7 5v7.111A7 7 0 0 0 5 17c0 3.859 3.141 7 7 7s7-3.141 7-7a7 7 0 0 0-2-4.889M12 22c-2.757 0-5-2.243-5-5 0-1.412.608-2.768 1.668-3.719.211-.19.332-.46.332-.745V4.999c0-1.654 1.346-3 3-3s3 1.346 3 3v7.537c0 .284.121.554.332.745A5 5 0 0 1 17 17c0 2.757-2.243 5-5 5"
    />
  </svg>
);
export default SvgFiRrThermometerFull;
